const API_BASE_URL = "https://fila-api.iti.gov.br/api";

export default API_BASE_URL;
